define('viewModels/privileged/qm/util/FileStateEnum',[], function () {
    'use strict';
    
    return {
        "AVAILABLE": "AVAILABLE",
        "ARCHIVED": "ARCHIVED",
        "ARCHIVING": "ARCHIVING",
        "RESTORING": "RESTORING",
        "RESTORED": "RESTORED",
        "UPLOADING": "UPLOADING",
        "DELETED": "DELETED"
    };
});
